import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { fetchFilter, deleteRecipe} from '../../../store/api.js'
import { InputText } from '../../atoms'
import { Select, FormAddRecipe, Selectdisign, SearchRecipe } from '../../molecules'
import { SideFilter, Recipe, Loader, ModalWindow, ModalInfo, CounterPage, SceletonRecipe, ErrorHandler, Popup } from '../../organisms'
import { useHistory , useLocation   } from 'react-router-dom' 
import { filtrSearchArr } from '../../../utils/utils.js'
import { sorts, filterSort } from '../../../constants/constants.js' 
import './Recipes.css'
import { useRef } from 'react'; 

export function Recipes(props) {
  const dispatch = useDispatch()
  const location = useLocation();
  const searchParams = new URLSearchParams();
  const queryString = searchParams.toString();
  const limit = 15
  const sortRef =  useRef()
  let history = useHistory() 
  const { lib, statusLib } = useSelector(state => state.lib)   
  const { currentUser, statusUser } = useSelector(state => state.currentUser)
  const {recipes, totalCount, fetching, edge, errorPage} = useSelector(state => state.recipes) 
  const {ingredients, status} = useSelector(state => state.ingredients)  
  const [sort, setSort] = React.useState(sorts[0]);
  const [recipe, setRecipe] = React.useState({});
  const [category, setCategory] = React.useState([])
  const [showFilterBlock, setShowFilterBlock] = React.useState(false)
  const [kitchenware, setKitchenware] = React.useState([])
  const [type, setType] = React.useState([])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);
  const [choiceIngredient, setChoiceIngredient] = React.useState([]) 
  const [isOpen, setIsOpen] = React.useState(false) // Открытие сортировки  
  const [isOpenForm, setIsOpenForm] = React.useState(false) 
  const [isFilterOpen, setIsFilterOpen] = React.useState(false);
  const [isAnimating, setIsAnimating] = React.useState(false);
  const [isOpenEdit, setIsOpenEdit] = React.useState(false) 
  const [showChoice, setShowChoice] = React.useState(false) // Показывает вопрос об удалении рецепта
  const allPages = Math.ceil(totalCount/limit)
  const pages = Array.from({length: allPages}, (_, i) => i + 1) 
  const [keyword, setKeyword] = React.useState('')  
  const [userId, setUserId] = React.useState('') 
  const [keywords, setKeywords] = React.useState('')
  const [hidden, sethidden] = React.useState(false)    
  const [wait, setWait] = React.useState(false) //нужен чтобы указать задержку для отрисовки результата        
  const [inputTimer, setInputTimer] = React.useState(null);  
  const [calsClick, setCalsClick] = React.useState(false); 
  const [filtrMassiv, setFiltrMassiv] = React.useState([]);
  let filters = JSON.parse(localStorage.getItem('filters'));
  const [minCalories, setMinCalories] = React.useState(0);
  const [maxCalories, setMaxCalories] = React.useState('');
  const [minTime, setMinTime] = React.useState('');
  const [maxTime, setMaxTime] = React.useState(''); 
  const [statusFilter, setStatusFilter] = React.useState(false)
  const [sortedKey, setSortedKey] = React.useState(filterSort[0])   

  React.useEffect(() => {
    const click = e => {
      if (isOpen && sortRef.current && !sortRef.current.contains(e.target) && !e.target.classList.contains('gg-sorting') ) {
        setIsOpen(false)
      }
    }
    document.addEventListener("mousedown", click)
    return () => {
      document.removeEventListener("mousedown", click)
    }
  }, [isOpen])
  

  //ErrorHandler(fetching, errorPage)
  const parametrSearch = {
    currentPage,
    params: filterSearch(),
    searchWords: choiceIngredient.length === 0 ? keyword : '',
    ingredient: parametrkeywords(),
    limit,
    sorter: sort.nameEn,
    like: statusFilter === 'likes' ? currentUser._id : '',
    owner: statusFilter === 'owner' ? currentUser._id : '',
    feast:  statusFilter === 'feast' ? true : '',
    userId: currentUser._id ? currentUser._id : '',
    minCalories: minCalories,
    maxCalories: maxCalories,
    minTime: minTime,
    maxTime: maxTime,
    filter: sortedKey.nameEn,
    user: userId,
    moderator: currentUser._id ?  currentUser.supervisor : false
  };


 React.useEffect(() => {
  if (isFilterOpen) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = '';
  }
  
  return () => {
    document.body.style.overflow = '';
  };
}, [isFilterOpen]);
 
 /* React.useEffect(() => {
    if (!filters && statusLib === 'resolved') { 
      setType(lib.typeFoods)
      setCategory(lib.dish)
      setKitchenware(lib.kitchenware)
      setSort(sorts[0])
    } else if(filters !==null && statusLib === 'resolved') { 
      setType(filters.type);
      setCategory(filters.category);
      setKitchenware(filters.kitchenware) 
      setSort(sorts[0])
    }
  }, [statusLib]) */

  React.useEffect(() => {
    if (statusLib !== 'resolved') return; 
    // Общая часть для всех случаев
    setSort(sorts[0]); 
    if (!filters) {
      // Если фильтров нет 
      setType(lib?.typeFoods || []);
      setCategory(lib?.dish || []);
      setKitchenware(lib?.kitchenware || []);
    } else { 
      // Если фильтры есть
      setType(filters?.type || []);
      setCategory(filters?.category || []);
      setKitchenware((filters?.kitchenware && filters.kitchenware.length > 0) ? filters.kitchenware : lib?.kitchenware);
    }
  }, [statusLib]);
 
  React.useEffect(() => { 
    if (currentPage && category.length > 0 && type.length > 0 && kitchenware.length > 0 && statusUser !== 'loading' ) { 
      dispatch(fetchFilter(parametrSearch)); 
    }
  }, [currentPage, category, type, choiceIngredient, kitchenware, sort, calsClick, statusFilter, statusUser, sortedKey, userId]);
  
/*React.useEffect(() => {  
  setMaxCalories(Math.round(edge.maxCalories))
  setMinCalories(Math.round(edge.minCalories))
}, [edge]); */

React.useEffect(() => {
  setWait(true)
  if (currentPage && category.length > 0 && type.length > 0) {
      clearTimeout(inputTimer);
      let timeout = setTimeout(() => { 
          parametrSearch.searchWords = keyword;
          dispatch(fetchFilter(parametrSearch));
          setWait(false)
      }, 1000);
      setInputTimer(timeout);
  }
  return () => clearTimeout(inputTimer)
}, [keyword]);

React.useEffect(() => {
  setCurrentPage(1);
  const params = filterSearch();
  history.push({
    pathname: '/recipes/',
    search: queryString ? `?${queryString}` : ''
  });
  if (type.length || category.length) {
      localStorage.setItem("filters", JSON.stringify({ type, category, kitchenware }));
  }
}, [category, type, kitchenware]);

// При переключении страниц скролл наверх
React.useMemo(() => {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}, [currentPage]);

// Видимость фильтров
React.useEffect(() => {
  document.body.classList.toggle('hidden', showFilterBlock);
}, [showFilterBlock]);

function handleCounter(page) {
  setCurrentPage(page);
}

function filterSearch() {
  return type.reduce((params, s) => s.boolean ? `${params}&types[]=${s.nameEn}` : params, '') +
         category.reduce((params, s) => s.boolean ? `${params}&dishes[]=${s.nameRu}` : params, '') +
         kitchenware.reduce((params, s) => s.boolean ? `${params}&kitchenware[]=${s.nameEn}` : params, '');
         
}
 
function handleChoiceOwner(e) {   
  setStatusFilter(e.target.value) 
  setCurrentPage(1);
}

function parametrkeywords() {
  let param=''
    choiceIngredient.map(i=> {
      param = param + `&keywords[]=${i._id}`
    })
  return param
}

function handleChoiceCategory(e) {
  const { name, checked } = e.target;  
  setCategory(() => category.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}


function handleChoiceType(e) {
  const { name, checked } = e.target; 
  setType((type) => type.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}

function handleChoiceTools(e) {
  const { name, checked } = e.target; 
  setKitchenware((tools) => tools.map((c) => c.nameEn === name ? {...c, boolean: checked } : c));
  setCurrentPage(1);
}


function handleFilterBlock() {
  setShowFilterBlock(prev => !prev);
}

function handleDeleteSearch(i) {
  setChoiceIngredient(prev => prev.filter(c => c._id !== i));
}

function handleAutoText(ing) {
  setChoiceIngredient(prev => [...prev, { _id: ing._id, name: ing.name }]);
  setCurrentPage(1)
  setKeywords('');
  setKeyword('')  
  sethidden(false);
}

function handleChangeInput(e) { 
  setCurrentPage(1)
  setKeyword(e.target.value)   
  sethidden(true);
  handleFiltrClick(e.target.value) 
}

function handleChangeInputId(e) { 
  setCurrentPage(1)
  setUserId(e.target.value)   
  
}

function handleReset() {
  setType(lib.typeFoods);
  setCategory(lib.dish);
  setKitchenware(lib.kitchenware)
  setChoiceIngredient([]);
  setKeyword('');
  localStorage.removeItem('filters');
  setCurrentPage(1);
  setSort(sorts[0])
}

function handleFiltrClick(keyword) {
  if (keyword) {
      setFiltrMassiv(filtrSearchArr(ingredients, keyword, 'ingredient'));
  } else {
      setFiltrMassiv([]);
      sethidden(false)
  }
}

  //Удаление рецепта
  function handleDelete() {
    dispatch(deleteRecipe(recipe._id)) 
    setShowChoice(false)
  }
 
  //Открытие модального для редактирования рецепта
  function handleEditRecipe(recipe) { 
    setIsOpenEdit(true)
    setRecipe(recipe)
    
  }

    //Закрытие модального для редактирования рецепта
  function handleModalClose() {
    setIsOpenEdit(false) 
    setShowChoice(false)
    setIsFilterOpen(false)
    setIsOpenForm(false)
  } 

  //Открытие модально с запросом проверки на удаление
  function handleDeleteRecipe(recipe) { 
    setShowChoice(true)
    setRecipe(recipe)
  }
 
  function handlePopupModal() {
    setIsOpen(!isOpen)
  }

  function handleChangeEvents(el) {  
    setSort(el)
  } 

  const handleCalChange = (e) => {
    const { name, value } = e.target; 
    // Проверка введенных значений
    if (name === 'cals-min') {
      setMinCalories(value);
    } else if (name === 'cals-max') {
      setMaxCalories(value);
    }
  };

  const handleTimeChange = (e) => {
    const { name, value } = e.target; 
    // Проверка введенных значений
    if (name === 'time-min') {
      setMinTime(value);
    } else if (name === 'time-max') {
      setMaxTime(value);
    }
  };
  const handleOpenFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  }
  const toggleModal = () => { 
      setIsAnimating(true);
      setTimeout(() => {
        setIsFilterOpen(false);
        setIsAnimating(false);
        setIsOpenEdit(false);
      }, 300); // Должно совпадать с duration анимации
    
  };
 

  function handleCalsClick () {
    setCalsClick(!calsClick)
    setCurrentPage(1)
  }
 
  const hiddenClose= () => {
    sethidden(false)
  }

  function hadleAddRecipe() { 
    setIsOpenForm(true)
  }

  function handleSorting(key) { 
    //dispatch(getRecipeOwner({page: currentPage, filter: key.nameEn}))
    setSortedKey(key) 
  }
 
  
    return (
      <>
      <title>Конструктор плана питания. Рецепты для составления плана питания</title>
      <meta name="description" content='Подберите рецепты для плана питания, с учетом типа питания, кбжу, цене , вес порции и ингредиентам' />   
     
      <div className={`recipes ${fetching === 'loading' ? 'loading' : ''}`} >
          {/* Фильтры на декстопе */}
      <div className='filter filter__deckstop'>
        <h3 className='font26EB color filter__title'>Фильтры</h3>
        {  statusLib=== 'resolved' &&
          <SideFilter 
            type={type}
            category={category}
            kitchenware={kitchenware}
            handleChoiceType={handleChoiceType}
            handleChoiceCategory={handleChoiceCategory} 
            handleChoiceTools={handleChoiceTools}
            fetching={fetching}
            name="addition"
            value={statusFilter}
            handleChoiceOwner={handleChoiceOwner}
            handleReset={handleReset}
            handleCalChange={handleCalChange}
            handleTimeChange={handleTimeChange}
            minCalories={minCalories}
            maxCalories={maxCalories}
            minTime={minTime}
            maxTime={maxTime}
            edge={edge}
            calsClick={handleCalsClick}
          />
        }
      </div>
     
       <div className='df-c relative widt100 g50'>
  
      <div className='searching '>
      <div className='search search__mobile'> 
        <SearchRecipe 
          handleChangeInput={handleChangeInput}
          filtrMassiv={filtrMassiv}
          choiceIngredient={choiceIngredient}
          keywords={keywords}
          keyword={keyword}
          handleChangeInputId={handleChangeInputId}
          userId={userId}
          handleAutoText={handleAutoText} 
          handleDelete={handleDeleteSearch} 
          hidden={hidden}
          hiddenClose={hiddenClose}
        />
        
      </div>
      <div className='sort df-r g20'>
      <button 
        className='filter__mobile-button gg-filter' 
        onClick={handleOpenFilter}
     / > 
     <button 
        className='filter__mobile-button gg-sorting' 
        onClick={handlePopupModal}
     > 
     <Popup isOpen={isOpen} ref={sortRef} type='sort'>
        {sorts.map((el, index) => (
          <p className='event-text font20Norm select-text_sorts'  key={index} onClick={()=> handleChangeEvents(el)}>{el.nameRu}</p>)
        )} 
      </Popup> 
      </button>
        <Selectdisign 
          data={sorts} 
          name={sort}
          type='recipes'
          //ref={sortRef}
          title='sort'
          isOpen={isOpen}
          handleChangeEvents={handleChangeEvents}
          handlePopupModal={handlePopupModal}
        /> 
      
      </div>
      
      </div>
      
      <div className='my-recipes__filters my-recipes__filter_deckstop'>
      {filterSort.map((option) => (
          <button
            key={option.nameEn}
            className={`font20EB buttonNone ${sortedKey.nameEn === option.nameEn ? 'color' : ''}`}
            onClick={() => handleSorting(option)}
          >
            {option.nameRu}
          </button>
        ))} 
        <button className='buttonGreen ' onClick={hadleAddRecipe}>Добавить рецепт</button>
      </div>
      <ul className='cards'>
        {recipes.length > 0 ?
        recipes.map((recipe, index) => (
         <Recipe recipe={recipe} key={recipe._id} handleEditRecipe={handleEditRecipe} handleDeleteRecipe={handleDeleteRecipe} type='recipe' handleAddRecipeinMeals={props.handleAddRecipeinMeals}/>
        ))
        : fetching === 'resolved' && recipes.length === 0 &&
        <div className='recipe_none'>
          <p className='gg-no-dish'></p> 
           <p className=' font20Nprm '>Ничего не найдено</p> 
        </div> 
        }
      
      </ul>
      <CounterPage handleCounter={handleCounter} pages={pages} currentPage={currentPage} totalCount={totalCount}/> 
      </div>
            {/* Фильтры на мобильной версии модалка */}
      {isFilterOpen && (
        <div className={`modal-overlay ${isAnimating ? 'closing' : ''}`} onClick={toggleModal}>
          <div 
            className={`modal-side ${isAnimating ? 'closing' : ''}`} 
            onClick={e => e.stopPropagation()}
          >
            <div className="modal-header">
              <h3 className='font20EB color filter__title'>Фильтры</h3>
              <button onClick={toggleModal} className="modal-close">×</button>
            </div>
            <div className="modal-content">
            <SideFilter 
            type={type}
            category={category}
            kitchenware={kitchenware}
            handleChoiceType={handleChoiceType}
            handleChoiceCategory={handleChoiceCategory} 
            handleChoiceTools={handleChoiceTools}
            fetching={fetching}
            name="addition"
            value={statusFilter}
            handleChoiceOwner={handleChoiceOwner}
            handleReset={handleReset}
            handleCalChange={handleCalChange}
            handleTimeChange={handleTimeChange}
            minCalories={minCalories}
            maxCalories={maxCalories}
            minTime={minTime}
            maxTime={maxTime}
            edge={edge}
            calsClick={handleCalsClick}
          />
            </div>
          </div>
        </div>
      )}
      {statusLib === 'resolved' && isOpenForm &&  
         <ModalWindow  onClose={handleModalClose} title='add-recipe' head='Добавить рецепт'>
           <FormAddRecipe onClose={handleModalClose}/>
        </ModalWindow>
       }

      
        {Object.keys(recipe).length !== 0  && statusLib === 'resolved' && isOpenEdit &&
          <ModalWindow onClose={handleModalClose} title='edit-recipe' head='Редактировать рецепт'  toggleModal={toggleModal}>
           <FormAddRecipe card={recipe && recipe} onClose={handleModalClose} isOpen={isOpenEdit} />
          </ModalWindow>
        }
       
      {Object.keys(recipe).length !== 0  && statusLib === 'resolved' && showChoice &&
        <ModalInfo  
       onClose={handleModalClose}   
       name='choice-delete'
       textError={`Подтвердите удаление рецепта "${recipe.name}"`}
       icon={false}
     >
     <div className="g10 flexRowCenter" > 
       <button onClick={handleDelete} className="buttonGrey font20Norm " type="button" aria-label={props.buttonName}>Да</button>
       <button onClick={handleModalClose} className="buttonGreen font20Norm " type="button" aria-label={props.buttonName}>Нет</button>
       </div>
     </ModalInfo>
      }
    
    </div>
    </>
    );
}
  